import { Mail, MapPin, Phone } from "lucide-react";
import ContactForm from "@/components/sections/ContactForm";

const contactEntries = [
  {
    slug: "vijay-oza",
    name: "Vijay K. Oza. (VJ) Director of Design - USA",
    address: "18913, Coral Grove Terrace, Germantown, MD 20874",
    office: null,
    cell: "201-286-2097",
    email: "Vjo@concept-magik.com",
  },
  {
    slug: "peter-dimicelli",
    name: "Peter DiMicelli. Regional Director of Projects - USA",
    address: null,
    office: null,
    cell: "864 921-9051",
    email: "doc1chef4@yahoo.com",
  },
  {
    slug: "nitin-tandon",
    name: "Nitin Tandon. Regional Director of Projects - Asia",
    address: null,
    office: null,
    cell: "(91) 98211-65808",
    email: null,
  },
];

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <section className="bg-slate-950 py-24 text-white md:py-28" data-testid="contact-hero-section">
        <div className="mx-auto max-w-5xl px-6 md:px-12">
          <div className="space-y-6">
            <div className="section-kicker text-orange-400" data-testid="contact-hero-kicker">Contact Us</div>
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="contact-hero-heading">
              Contact Us
            </h1>
            <p className="max-w-4xl text-base text-slate-300 md:text-lg" data-testid="contact-hero-description">
              Vijay K. Oza. (VJ) Director of Design - USA
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-28" data-testid="contact-form-section">
        <div className="mx-auto grid max-w-7xl gap-10 px-6 md:px-12 lg:grid-cols-[1fr_1fr]">
          <div className="space-y-6">
            {contactEntries.map((entry) => (
              <article
                key={entry.slug}
                className="border border-slate-200 bg-slate-50 p-8"
                data-testid={`contact-entry-${entry.slug}`}
              >
                <h2 className="text-2xl font-bold tracking-tight text-slate-950" data-testid={`contact-entry-name-${entry.slug}`}>
                  {entry.name}
                </h2>

                <div className="mt-6 grid gap-4 text-base text-slate-700">
                  {entry.address ? (
                    <div className="flex items-start gap-3" data-testid={`contact-entry-address-${entry.slug}`}>
                      <MapPin className="mt-1 h-5 w-5 text-orange-600" />
                      <span>{entry.address}</span>
                    </div>
                  ) : null}

                  {entry.office ? (
                    <a
                      className="flex items-center gap-3 text-slate-700 transition-colors hover:text-slate-950"
                      data-testid={`contact-entry-office-${entry.slug}`}
                      href={`tel:${entry.office}`}
                    >
                      <Phone className="h-5 w-5 text-orange-600" />
                      <span>Office: {entry.office}</span>
                    </a>
                  ) : null}

                  <a
                    className="flex items-center gap-3 text-slate-700 transition-colors hover:text-slate-950"
                    data-testid={`contact-entry-cell-${entry.slug}`}
                    href={`tel:${entry.cell}`}
                  >
                    <Phone className="h-5 w-5 text-orange-600" />
                    <span>Cell: {entry.cell}</span>
                  </a>

                  {entry.email ? (
                    <a
                      className="flex items-center gap-3 break-all text-slate-700 transition-colors hover:text-slate-950"
                      data-testid={`contact-entry-email-${entry.slug}`}
                      href={`mailto:${entry.email}`}
                    >
                      <Mail className="h-5 w-5 text-orange-600" />
                      <span>Email: {entry.email}</span>
                    </a>
                  ) : null}
                </div>
              </article>
            ))}
          </div>

          <div className="border border-slate-200 bg-slate-50 p-8 md:p-10" data-testid="contact-form-panel">
            <div className="mb-6 space-y-3">
              <div className="section-kicker" data-testid="contact-form-kicker">Contact Form</div>
              <h2 className="text-3xl font-bold tracking-tight text-slate-950" data-testid="contact-form-heading">
                Contact Form
              </h2>
            </div>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}